import { render, staticRenderFns } from "./ProductSearchAreaOrder.vue?vue&type=template&id=c385a2e6&scoped=true&"
import script from "./ProductSearchAreaOrder.vue?vue&type=script&lang=js&"
export * from "./ProductSearchAreaOrder.vue?vue&type=script&lang=js&"
import style0 from "./ProductSearchAreaOrder.vue?vue&type=style&index=0&id=c385a2e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c385a2e6",
  null
  
)

export default component.exports